/* eslint-disable */

<template>
  <div>

    <vue-sortable :options="options" @drag:start="startedDrag" @drag:stop="stoppedDrag" @sortable:sort="sort">
      <div class="vx-row " :class="{'cursor-drag' : draggingCard === true}">
        <div class="vx-col lg:w-3/12 md:w-3/12 sm:w-5/5">
          <vx-card class="mb-base">
            <h3 class="font-bold mb-4 p-2 rounded" style="background-color: #0084ff">Drag and Drop</h3>
            <div class="flex items-between align-middle my-2 dataClassificationBlock">
              <h4 class="self-center pr-8">Bound copies of internal audit reports from a private company</h4>
              <vue-draggable-container id="wb1" class="wbDataClassification">
                <h5 class="dragBlock dataClassificationDragBlock cursor-pointer-simulation">1</h5>
              </vue-draggable-container>
            </div>
            <div class="flex items-between align-middle my-2 dataClassificationBlock">
              <h4 class="self-center pr-8">Copies of financial audit reports from exchange-traded organizations on a
                flash drive</h4>
              <vue-draggable-container id="wb2" class="wbDataClassification">
                <h5 class="dragBlock dataClassificationDragBlock cursor-pointer-simulation">2</h5>
              </vue-draggable-container>
            </div>
            <div class="flex items-between align-middle my-2 dataClassificationBlock">
              <h4 class="self-center pr-8">Database containing drivers license information on a reusable backup tape</h4>
              <vue-draggable-container id="wb3" class="wbDataClassification">
                <h5 class="dragBlock dataClassificationDragBlock cursor-pointer-simulation">3</h5>
              </vue-draggable-container>
            </div>
            <div class="flex items-between align-middle my-2 dataClassificationBlock">
              <h4 class="self-center pr-8">Decommissioned mechanical hard drive containing application source code</h4>
              <vue-draggable-container id="wb4" class="wbDataClassification">
                <h5 class="dragBlock dataClassificationDragBlock cursor-pointer-simulation">4</h5>
              </vue-draggable-container>
            </div>
            <div class="flex items-between align-middle my-2 dataClassificationBlock">
              <h4 class="self-center pr-8">Employee records on a Solid State Drive (SSD)</h4>
              <vue-draggable-container id="wb5" class="wbDataClassification">
                <h5 class="dragBlock dataClassificationDragBlock cursor-pointer-simulation">5</h5>
              </vue-draggable-container>
            </div>
            <div class="flex items-between align-middle my-2 dataClassificationBlock"
                 style="border-width:  2px 0 2px 0">
              <h4 class="self-center pr-8">Paper-based customer records, which include medical data</h4>
              <vue-draggable-container id="wb6" class="wbDataClassification">
                <h5 class="dragBlock dataClassificationDragBlock cursor-pointer-simulation">6</h5>
              </vue-draggable-container>
            </div>
          </vx-card>
        </div>
        <div class="vx-col lg:w-9/12 md:w-9/12 sm:w-5/5">
          <vx-card class="mb-base">
            <div class="fourth-sim pt-0" @click="click_remove">
              <div class="vx-row mb-4">

                <div class="vx-col w-6/12 p-5 rounded">
                  <h2 class="font-bold p-2 rounded" style="background-color: #0084ff">Data Classification</h2>
                  <div class="border-white border-2 border-solid rounded p-4 my-4" style="background-color: #001a95" >
                    <h4 class="font-semibold mb-2">PII</h4>
                    <vue-draggable-container class="dropzone dropzoneStandard answer-bg answerDataClassification" id="inputPII"/>
                  </div>
                  <div class="border-white border-2 border-solid rounded p-4 my-4" style="background-color: #001a95" >
                    <h4 class="font-semibold mb-2">PHI</h4>
                    <vue-draggable-container class="dropzone dropzoneStandard answer-bg answerDataClassification" id="inputPHI"/>
                  </div>
                  <div class="border-white border-2 border-solid rounded p-4 my-4" style="background-color: #001a95" >
                    <h4 class="font-semibold mb-2">Intellectual Property</h4>
                    <vue-draggable-container class="dropzone dropzoneStandard answer-bg answerDataClassification" id="inputIP"/>
                  </div>
                  <div class="border-white border-2 border-solid rounded p-4 my-4" style="background-color: #001a95" >
                    <h4 class="font-semibold mb-2">Corporate Confidential</h4>
                    <vue-draggable-container class="dropzone dropzoneStandard answer-bg answerDataClassification" id="inputCC"/>
                  </div>
                  <div class="border-white border-2 border-solid rounded p-4 my-4" style="background-color: #001a95" >
                    <h4 class="font-semibold mb-2">Public</h4>
                    <vue-draggable-container class="dropzone dropzoneStandard answer-bg answerDataClassification" id="inputPUB"/>
                  </div>
                </div>

                <div class="vx-col w-6/12 p-5 rounded">
                  <h2 class="font-bold p-2 rounded" style="background-color: #0084ff">Data Destruction Method</h2>
                  <div class="border-white border-2 border-solid rounded p-4 my-4" style="background-color: #001a95" >
                    <h4 class="font-semibold mb-2">Degaussing and Multi-Pass Wipe</h4>
                    <vue-draggable-container class="dropzone dropzoneStandard answer-bg answerDataClassification" id="inputDAMPW"/>
                  </div>
                  <div class="border-white border-2 border-solid rounded p-4 my-4" style="background-color: #001a95" >
                    <h4 class="font-semibold mb-2">Physical Destruction via Shredding</h4>
                    <vue-draggable-container class="dropzone dropzoneStandard answer-bg answerDataClassification" id="inputPDVS"/>
                  </div>
                </div>

              </div>
            </div>
          </vx-card>
        </div>
      </div>
    </vue-sortable>

  </div>
</template>

<script>

import draggable from 'vuedraggable'
import Prism from 'vue-prism-component'

export default {
  data () {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      draggingCard: false,
      //last_drag_error: false,

      options: {
        draggable: '.dragBlock',
        dropzone: '.dropzoneStandard'

      }
    }
  },
  methods: {
    startedDrag (x) {
      x.data.source.className += ' currently-dragging-standard'
      const uuid = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
      this.draggingCard = true
      x.data.originalSource.id = uuid
      const originalNode = x.data.originalSource
      const clonedNode = originalNode.cloneNode(true)
      clonedNode.classList.add('clonedElement')
      clonedNode.id += '-cloned'
      originalNode.parentNode.insertBefore(clonedNode, originalNode.nextSibling)
    },
    stoppedDrag () {
      this.draggingCard = false
    },
    sort (x) {
      const overContainer = x.data.dragEvent.data.overContainer
      const origSourceContainer = x.data.dragEvent.data.originalSource
      if (overContainer.classList.contains('wbDataClassification')) {
        if (overContainer.children.length > 0) {
          return x.cancel()
        }
      }
      if (overContainer && overContainer.classList.contains('dropzone')) {
        const id = origSourceContainer.id
        document.getElementById(`${id  }-cloned`).style.display = 'inline-flex'
        document.getElementById(id).classList.remove('dragBlock')
        document.getElementById(id).classList.add('stillBlockDataClassification')
        return
      }
      document.getElementById(`${origSourceContainer.id  }-cloned`).outerHTML = ''
    },
    markSimulation () {

      let total_score = 0

      const inputPII = document.getElementById('inputPII')
      if (inputPII.textContent === '53' || inputPII.textContent === '35') {
        inputPII.style.borderColor = '#28C76F'
        inputPII.style.backgroundColor = '#28C76F'
        total_score++
        total_score++
      } else {
        inputPII.style.borderColor = '#fd4445'
        inputPII.style.backgroundColor = '#fd4445'
      }

      if (document.getElementById('inputPHI').textContent  === '6') {
        document.getElementById('inputPHI').style.borderColor = '#28C76F'
        document.getElementById('inputPHI').style.backgroundColor = '#28C76F'
        total_score++
      } else {
        document.getElementById('inputPHI').style.borderColor = '#fd4445'
        document.getElementById('inputPHI').style.backgroundColor = '#fd4445'
      }

      if (document.getElementById('inputIP').textContent  === '4') {
        document.getElementById('inputIP').style.borderColor = '#28C76F'
        document.getElementById('inputIP').style.backgroundColor = '#28C76F'
        total_score++
      } else {
        document.getElementById('inputIP').style.borderColor = '#fd4445'
        document.getElementById('inputIP').style.backgroundColor = '#fd4445'
      }

      if (document.getElementById('inputCC').textContent  === '1') {
        document.getElementById('inputCC').style.borderColor = '#28C76F'
        document.getElementById('inputCC').style.backgroundColor = '#28C76F'
        total_score++
      } else {
        document.getElementById('inputCC').style.borderColor = '#fd4445'
        document.getElementById('inputCC').style.backgroundColor = '#fd4445'
      }

      if (document.getElementById('inputPUB').textContent  === '2') {
        document.getElementById('inputPUB').style.borderColor = '#28C76F'
        document.getElementById('inputPUB').style.backgroundColor = '#28C76F'
        total_score++
      } else {
        document.getElementById('inputPUB').style.borderColor = '#fd4445'
        document.getElementById('inputPUB').style.backgroundColor = '#fd4445'
      }

      if (document.getElementById('inputDAMPW').textContent  === '3') {
        document.getElementById('inputDAMPW').style.borderColor = '#28C76F'
        document.getElementById('inputDAMPW').style.backgroundColor = '#28C76F'
        total_score++
      } else {
        document.getElementById('inputDAMPW').style.borderColor = '#fd4445'
        document.getElementById('inputDAMPW').style.backgroundColor = '#fd4445'
      }

      const inputPDVS = document.getElementById('inputPDVS')
      const answerPDVS = [1, 2, 4, 6, 5]
      inputPDVS.childNodes.forEach(item => {
        const text = parseInt(item.textContent)
        const index = answerPDVS.indexOf(text)
        if (index > -1) {
          answerPDVS.splice(index, 1)
        }
      })

      const scorePDVS = 5 - answerPDVS.length
      if (scorePDVS === 5 && inputPDVS.childNodes.length === 5) {
        inputPDVS.style.borderColor = '#28C76F'
        inputPDVS.style.backgroundColor = '#28C76F'
        total_score = total_score + 5
      } else {
        inputPDVS.style.borderColor = '#fd4445'
        inputPDVS.style.backgroundColor = '#fd4445'
      }


      if (total_score === this.dataLocal.legacy.total_score) {
        return this.$emit('simulation_full_correct', total_score)
      }

      this.$emit('simulation_getting_there', total_score)

    },
    click_remove (x) {
      const target = x.target
      if (target.classList.contains('stillBlockDataClassification')) {
        target.outerHTML = ''
      }
    }
  },
  components: {
    draggable,
    Prism
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  }

}
</script>
<style >
.dataClassificationDragBlock {
  min-width: 50px!important;
  background-color: #ffd900;
  color: #000000!important;
  font-weight: 800!important;
}

.dataClassificationBlock {
  border-color: #ffffff;
  border-style: solid;
  border-width: 2px 0 0 0;
  padding: 7px 0 7px 0;
}

.answerDataClassification {
  min-height: 57.5px;

}

.wbDataClassification {
  min-width: 65px;
  min-height: 55px;
  border: 1px solid rgba(255, 255, 255, 0.75);
  justify-content: center;
  display: flex;

}

.stillBlockDataClassification {
  padding: 12px;
  word-break: break-all;
  background-color:  rgba(var(--vs-primary),1);
  display: inline-flex;
  margin: 5px;
  border-radius: 5px;
  font-size: 1.4rem;
  text-align: center;
  justify-content: center;
  align-items: center;
  z-index: 999999999999 !important;
  border: 0.180rem solid transparent;
  font-weight: 800!important;
  cursor: url('~@/assets/images/cursor/trash-cursor.png'), auto!important;
  background-color: #ffd900;
  color: #000000!important;
}

</style>
